import SmoothScroll from "@/components/site/SmoothScroll";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Footer from "@/components/site/Footer";
import {
  Problem,
  WhyNow,
  WhatNatsu,
  Architecture,
  ProductPreview,
  Workflow,
  Governance,
  Value,
  WhyNatsu,
  PilotJourney,
  About,
  PilotEnquiry,
} from "@/components/site/Sections";

export default function Home() {
  return (
    <SmoothScroll>
      <div className="relative">
        <Navbar />
        <main>
          <Hero />
          <Problem />
          <WhyNow />
          <WhatNatsu />
          <Architecture />
          <ProductPreview />
          <Workflow />
          <Governance />
          <Value />
          <WhyNatsu />
          <PilotJourney />
          <About />
          <PilotEnquiry />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
